import { 
    gql, 
    useQuery 
} from "@apollo/client";
import { 
    FindAdminAdminByIdQueryQuery, 
    FindAdminAdminByIdQueryQueryVariables
} from "../../../../../schemaTypes";

export const findAdminAdminByIdQuery = gql`
  query FindAdminAdminByIdQuery (
        $id: String!
    ) {
    findAdminAdminById(
        id: $id
    ) {
      adminId
      userId
      shortId
      profilePicture
      firstname
      lastname
      email
      phone
      level
      suspended
      userIsDeactivated
      userIsLocked
      createdAt
      updatedAt
    }
  }
`;

export interface WithFindAdminAdminById {
  match: FindAdminAdminByIdQueryQuery["findAdminAdminById"] | null;
  loading: boolean;
}

interface Props {
  id: string;
  children: (data: WithFindAdminAdminById) => React.ReactElement | null;
}

export const FindAdminAdminByIdController: React.FC<Props> = ({ id, children }) => {
  const { data, loading } = useQuery<
  FindAdminAdminByIdQueryQuery,
  FindAdminAdminByIdQueryQueryVariables
  >(
    findAdminAdminByIdQuery, {
      variables: { id }
    }
);

  let match: FindAdminAdminByIdQueryQuery["findAdminAdminById"] | null = null;
  if (data && data?.findAdminAdminById) {
    match = data?.findAdminAdminById;
  }

  return children({
    match,
    loading
  });
};